import { fromJS } from 'immutable';
import { actions } from 'react/api/actions/photoGallery';

const initialState = fromJS({
  largePhotos: {},
  currentPhotoId: null
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.setCurrentPhotoId:
      return state.set('currentPhotoId', action.payload);
    case actions.fetchLargePhoto:
      return state.setIn(['largePhotos', `${action.payload}`, 'isLoading'], true);
    case actions.fetchLargePhotoSucceeded:
      return state.mergeIn(['largePhotos', `${action.payload.id}`], { isLoading: false, ...action.payload });
    case actions.resetState:
      return initialState;
    default:
      return state;
  }
};
